import React, { FC, useEffect, useRef } from "react";

interface IInfiniteScrollProps extends React.ComponentPropsWithRef<"div"> {
  fetchNextPage: () => any;
  hasNextPage: boolean;
  isLoading: boolean;
  isEmpty: boolean;
  loadingMessage: React.ReactNode;
  endingMessage: React.ReactNode;
  emptyMessage: React.ReactNode;
}

const InfiniteScroll: FC<IInfiniteScrollProps> = ({
  fetchNextPage,
  hasNextPage,
  isLoading,
  isEmpty,
  loadingMessage,
  endingMessage,
  emptyMessage,
  children,
  ...props
}) => {
  const observerTarget: React.MutableRefObject<any> = useRef(null);

  useEffect(() => {
    const observer: IntersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          !isLoading && hasNextPage && fetchNextPage();
        }
      },
      { threshold: 1 }
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current);
      }
    };
  }, [observerTarget, fetchNextPage, hasNextPage, isLoading]);

  return (
    <div className="flex flex-col flex-1">
      <div {...props}>{children}</div>
      {hasNextPage && <div ref={observerTarget}></div>}
      {isLoading && loadingMessage}
      {!isLoading && !hasNextPage && !isEmpty && endingMessage}
      {isEmpty && (
        <div className="flex flex-1 items-center justify-center">
          {emptyMessage}
        </div>
      )}
    </div>
  );
};

export default InfiniteScroll;